
import { defineComponent, toRefs, reactive, onMounted } from "vue";
import Header from "@/components/Header.vue";
import Aside from "@/components/Aside_v1.vue";
export default defineComponent({
  components: {
    Header,
    Aside,
  },
  setup() {
    const state = reactive({
      isOpenMenu: false
    });

    return {
      ...toRefs(state),
    };
  },
});
